export default __webpack_public_path__ + "static/media/user.1416ec52.svg";